import type { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { IconWarning } from '@xing-com/icons';
import { spaceM } from '@xing-com/tokens';
import { BodyCopy } from '@xing-com/typography';

const StyledErrorContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 150px;
  text-align: center;
`;

const StyledErrorIconContainer = styled.div`
  margin-bottom: ${spaceM};
`;

export const FlagError: FC = () => (
  <StyledErrorContainer>
    <StyledErrorIconContainer>
      <IconWarning width={24} height={24} />
    </StyledErrorIconContainer>
    <BodyCopy size="small" lineHeight="dense" noMargin>
      <FormattedMessage id="USER_FLAG_ERROR_PARAGRAPH_1" /> <br />
      <FormattedMessage id="USER_FLAG_ERROR_PARAGRAPH_2" />
    </BodyCopy>
  </StyledErrorContainer>
);
